// import { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSession } from '../context/SessionContext'
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

/**
 * Custon `PrivateRoute` component declaration.
 * @param {Any} component
 * @return PrivateRoute
 */
const PrivateRoute = ({ component: Component, ...props }: any): JSX.Element => {
  const { autenticated, token } = useSession()

  return (
    <Route
      {...props}
      render={(props) =>
        !autenticated || !token ? (
          <Redirect to="/login" />
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}

export default PrivateRoute